import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { contentMetricsRepository } from '../repositories/contentMetrics.repository';
import { contentKeys } from '../services/content.keys';
import type { MetricsHistoryEntry } from '../types/content.types';

export const useMetricsHistory = (contentSubmissionId: string | null) => {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id || '';

  return useQuery({
    queryKey: contentKeys.metricsHistory(orgId, contentSubmissionId),
    queryFn: async (): Promise<MetricsHistoryEntry[]> => {
      if (!contentSubmissionId || !orgId) return [];
      return contentMetricsRepository.getMetricsHistory(orgId, contentSubmissionId);
    },
    enabled: !!contentSubmissionId && !!orgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
